var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { isFunction } from "lodash";
import React from "react";
import { findDOMNode } from "react-dom";
import { Loader, MediaItemErrorMsg } from "./../../ui-components";
import { ROOT } from "../dataHooks";
import styles from "../statics/styles/default-video-styles-scss";
import { VideoViewer } from "../viewer/video-viewer";
class VideoComponent extends React.Component {
  constructor(props) {
    super(props);
    __publicField(this, "durationFixTimeoutId");
    __publicField(this, "handleReady", (player) => {
      if (!this.state.isLoaded) {
        this.setState({ isLoaded: true });
      }
      this.handleDuration(player);
    });
    __publicField(this, "handleDuration", (player) => {
      setTimeout(() => {
        const duration = player.current?.getDuration();
        if (duration) {
          this.saveDurationToData(duration);
        } else {
          this.setState({ shouldRenderDurationFix: true });
        }
      }, 3e3);
    });
    __publicField(this, "renderLoader", () => {
      const isCustomVideo = "video" in this.props.componentData && !!this.props.componentData.video?.src?.id;
      return /* @__PURE__ */ React.createElement("div", { className: styles.videoOverlay }, /* @__PURE__ */ React.createElement(
        Loader,
        {
          type: "medium",
          isVerySlowFakeLoader: isCustomVideo,
          percent: this.props.loadingPercentage,
          disableProgress: !this.props.isLoading && !this.state.isLoaded
        }
      ));
    });
    __publicField(this, "saveDurationToData", (duration) => {
      const { componentData, updateAttributes } = this.props;
      const video = "video" in componentData ? componentData.video : {};
      updateAttributes({ ...componentData, video: { ...video || {}, duration } });
    });
    __publicField(this, "renderPlayer", () => {
      const { componentData, config, nodeId } = this.props;
      return /* @__PURE__ */ React.createElement(
        VideoViewer,
        {
          componentData,
          config,
          onReady: this.handleReady,
          isLoaded: this.state.isLoaded,
          key: this.state.iosFixKey,
          nodeId,
          isLight: false,
          disabled: true
        }
      );
    });
    __publicField(this, "renderPlayerDurationFix", () => {
      const { componentData, config, nodeId } = this.props;
      const play = (player) => {
        const internalPlayer = player.current?.getInternalPlayer();
        if (internalPlayer && "play" in internalPlayer && isFunction(internalPlayer.play)) {
          internalPlayer.play();
          return true;
        }
        return false;
      };
      const onReady = (player) => {
        const hasPlayed = play(player);
        if (hasPlayed) {
          return;
        }
        this.durationFixTimeoutId = setTimeout(() => {
          play(player);
        }, 1e4);
      };
      return /* @__PURE__ */ React.createElement("div", { className: styles.hide_duration }, /* @__PURE__ */ React.createElement(
        VideoViewer,
        {
          componentData,
          config,
          onReady,
          isLight: false,
          onDuration: (duration) => {
            this.setState({ shouldRenderDurationFix: false });
            this.saveDurationToData(duration);
            clearTimeout(this.durationFixTimeoutId);
          },
          nodeId,
          muted: true
        }
      ));
    });
    this.state = {
      isLoaded: false,
      iosFixKey: 1
    };
  }
  componentDidMount() {
    this.handlePlayerFocus();
  }
  componentDidUpdate() {
    this.handlePlayerFocus();
  }
  componentWillUnmount() {
    clearTimeout(this.durationFixTimeoutId);
  }
  handlePlayerFocus() {
    const element = findDOMNode(this)?.querySelector?.("iframe, video");
    if (element) {
      element.tabIndex = -1;
    }
  }
  render() {
    const {
      t,
      componentData: { error },
      isLoading
    } = this.props;
    const { isLoaded, shouldRenderDurationFix } = this.state;
    const loading = isLoading || !isLoaded;
    return /* @__PURE__ */ React.createElement("div", { "data-hook": ROOT, className: styles.video_container }, /* @__PURE__ */ React.createElement("div", { className: styles.video_overlay }), this.renderPlayer(), shouldRenderDurationFix ? this.renderPlayerDurationFix() : null, loading && !error && this.renderLoader(), error && /* @__PURE__ */ React.createElement(MediaItemErrorMsg, { error, t }));
  }
}
export {
  VideoComponent
};
//# sourceMappingURL=video-component.js.map
